import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=ad1ffb32"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad1ffb32')) {
      api.createRecord('ad1ffb32', component.options)
    } else {
      api.reload('ad1ffb32', component.options)
    }
    module.hot.accept("./Images.vue?vue&type=template&id=ad1ffb32", function () {
      api.rerender('ad1ffb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/Images.vue"
export default component.exports